var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowLeft = function SvgArrowLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70721 12.7068C9.89468 12.5191 10 12.2645 10 11.999C10 11.7335 9.89468 11.4788 9.70721 11.2911L6.41421 7.99395L9.70721 4.69683C9.88937 4.50799 9.99017 4.25508 9.98789 3.99255C9.98561 3.73003 9.88044 3.4789 9.69503 3.29326C9.50962 3.10762 9.25881 3.00232 8.99661 3.00004C8.73442 2.99776 8.48182 3.09868 8.29321 3.28106L4.29321 7.28607C4.10574 7.47383 4.00043 7.72846 4.00043 7.99396C4.00043 8.25945 4.10574 8.51408 4.29322 8.70184L8.29321 12.7068C8.48074 12.8946 8.73505 13 9.00021 13C9.26538 13 9.51969 12.8946 9.70721 12.7068Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-left.cac4ad29c1f3687d5f4dcf84c3ab79c8.svg";